const translations = {
  en: {
    homepage: {
      title: "Welcome to IcaroLife",
      description: "Your connected health platform",
      features: {
        patients: {
          title: "Patients",
          description: "Manage your health easily",
        },
        doctors: {
          title: "Doctors",
          description: "Connect with your patients",
        },
      },
    },
    slogan: "Connected Health: Where Patients and Doctors Meet",
    pacientes: "Patients",
    doctores: "Doctors",
    gestionCitas: "Appointment management and reminders",
    historial: "Digital medical history",
    consultas: "Consultations via WhatsApp or App",
    chatear: "Chat on WhatsApp",
    descargarPaciente: "Download Patient App",
    panel: "Professional panel and agenda",
    remotas: "Secure remote consultations",
    gestionPagos: "Patient and payment management",
    accesoDoctores: "Doctor Access",
    descargarDoctor: "Download Doctor App",
    contacto: "contact@icarolife.ai",
    facebook: "Facebook",
    derechos: "© 2025 IcaroLife - All rights reserved.",
    entrarDashboardDoctor: "Go to Doctor Dashboard",
    entrarDashboardPaciente: "Go to Patient Dashboard",
    accesoPacientes: "Patient Access",
    verFeatures: "View all features",
    ocultarFeatures: "Hide features",
  },
  es: {
    homepage: {
      title: "Bienvenido a IcaroLife",
      description: "Tu plataforma de salud conectada",
      features: {
        patients: {
          title: "Pacientes",
          description: "Gestiona tu salud fácilmente",
        },
        doctors: {
          title: "Doctores",
          description: "Conéctate con tus pacientes",
        },
      },
    },
    slogan: "La Salud Conectada: Donde Pacientes y Doctores se Encuentran",
    pacientes: "Pacientes",
    doctores: "Doctores",
    gestionCitas: "Gestión de citas y recordatorios",
    historial: "Historial médico digital",
    consultas: "Consultas por WhatsApp o App",
    chatear: "Chatear por WhatsApp",
    descargarPaciente: "Descargar App Paciente",
    panel: "Panel profesional y agenda",
    remotas: "Consultas remotas seguras",
    gestionPagos: "Gestión de pacientes y pagos",
    accesoDoctores: "Acceso para Doctores", // o "Doctor Access"
    descargarDoctor: "Descargar App Doctores",
    contacto: "contacto@icarolife.ai",
    facebook: "Facebook",
    derechos: "© 2025 IcaroLife - Todos los derechos reservados.",
    entrarDashboardDoctor: "Entrar al Dashboard Doctor",
    entrarDashboardPaciente: "Entrar al Dashboard Paciente",
    accesoPacientes: "Acceso para Pacientes", // o "Patient Access"
    verFeatures: "Ver todas las características",
    ocultarFeatures: "Ocultar características",
  },
};

export default translations;